import { Controller } from "stimulus"
import {
  PAYMENT_CHALLENGE_ACTION,
  isFatalPaymentChallengeError,
  storePaymentChallengeError
} from "../utils/payment_security"

// Turnstile does not reliably auto-render inside hidden wizard steps or modals. Wait until the
// challenge itself is visible, then render it explicitly.
export default class extends Controller {
  static targets = ["widget"]

  connect() {
    this.renderWhenVisible = this.renderWhenVisible.bind(this)
    this.observer = new MutationObserver(this.renderWhenVisible)
    this.observer.observe(document.documentElement, { attributes: true, childList: true, subtree: true })
    this.renderWhenVisible()
  }

  disconnect() {
    this.observer?.disconnect()
    clearTimeout(this.retryTimer)
  }

  renderWhenVisible() {
    if (this.widgetId || !this.widgetTarget.offsetParent) return
    if (!window.turnstile) {
      clearTimeout(this.retryTimer)
      this.retryTimer = setTimeout(this.renderWhenVisible, 100)
      return
    }

    this.widgetId = window.turnstile.render(this.widgetTarget, {
      sitekey: this.widgetTarget.dataset.sitekey,
      appearance: this.widgetTarget.dataset.appearance,
      action: this.widgetTarget.dataset.action || PAYMENT_CHALLENGE_ACTION,
      'response-field-name': this.widgetTarget.dataset.responseFieldName,
      callback: (token) => {
        delete this.widgetTarget.dataset.turnstileError
        this.element.dispatchEvent(new CustomEvent('payment-challenge:ready', {
          bubbles: true,
          detail: { token }
        }))
      },
      // Configuration errors (110xxx, e.g. 110200 domain not authorized) will not recover — store
      // them so waitForPaymentChallenge can fail immediately even if Review attaches later. Other
      // codes return false so Turnstile keeps retrying within the wait timeout.
      'error-callback': (errorCode) => {
        const code = String(errorCode || '')
        if (!isFatalPaymentChallengeError(code)) return false

        storePaymentChallengeError(this.element, code)
        this.element.dispatchEvent(new CustomEvent('payment-challenge:error', {
          bubbles: true,
          detail: { errorCode: code }
        }))
        return true
      }
    })
    this.widgetTarget.dataset.turnstileWidgetId = this.widgetId
    this.observer.disconnect()
  }
}
